<template>
  <div>
    <b-modal
      id="modal_form"
      size="lg"
      ref="modal_form"
      :title="modal_titulo"
      :ok-title="modal_botao"
      close-title="Fechar"
      cancel-title="Cancelar"
      :ok-disabled="form.errors.any()"
      v-model="showModal"
      @ok="handleOk"
    >
      <form
        @submit.stop.prevent="handleOk"
        @keydown="form.errors.clear($event.target.name)"
      >
        <b-container fluid class="p-a-0">
          <b-row no-gutters>
            <label><strong>Detalhes</strong></label>
          </b-row>
          <b-row no-gutters>
            <b-col>
              <label>Tipo</label>
              <b-form-group>
                <b-form-radio-group
                  v-model="helpForm.tp_fatura"
                  :options="this.$parent.optionsTpFatura"
                  plain
                ></b-form-radio-group>
              </b-form-group>
              <b-form-feedback
                class="text-danger"
                v-text="helpForm.errors.get('tp_fatura')"
                v-if="helpForm.errors.has('tp_fatura')"
              ></b-form-feedback>
            </b-col>
            <b-col>
              <label
                v-if="
                  this.helpForm.tp_fatura != 3 && this.helpForm.tp_fatura != 4
                "
                >Nº Fatura</label
              >
              <label
                v-if="
                  this.helpForm.tp_fatura == 3 || this.helpForm.tp_fatura == 4
                "
                >Nº NFSe</label
              >
              <b-form-input
                type="text"
                placeholder="Nº Fatura"
                v-model="helpForm.num_fiscal"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="helpForm.errors.get('num_fiscal')"
                v-if="helpForm.errors.has('num_fiscal')"
              ></b-form-feedback>
            </b-col>

            <b-col>
              <label>Serie</label>
              <b-form-input
                type="text"
                placeholder="Serie"
                v-model="helpForm.serie"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="helpForm.errors.get('serie')"
                v-if="helpForm.errors.has('serie')"
              ></b-form-feedback>
            </b-col>

            <b-col>
              <label>Nº Pré-Fatura</label>
              <b-form-input
                type="text"
                placeholder="Nº Pré-Fatura"
                v-model="helpForm.prefat_num_fiscal"
                @change="searchPreFatura()"
                :readonly="
                  this.helpForm.tp_fatura == 3 || this.helpForm.tp_fatura == 4 || this.helpForm.tp_fatura == 5
                "
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="helpForm.errors.get('nfse_num_fiscal')"
                v-if="helpForm.errors.has('nfse_num_fiscal')"
              ></b-form-feedback>
            </b-col>

            <b-col
              v-if="
                this.helpForm.tp_fatura != 3 && this.helpForm.tp_fatura != 4
              "
            >
              <label>Transportadora</label>
              <b-form-input
                type="text"
                placeholder="Transportadora"
                v-model="helpForm.transportadora"
                readonly
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="helpForm.errors.get('transportadora')"
                v-if="helpForm.errors.has('transportadora')"
              ></b-form-feedback>
            </b-col>

            <b-col
              v-if="
                this.helpForm.tp_fatura == 3 || this.helpForm.tp_fatura == 4
              "
            >
              <label>Transportadora</label>
              <multiselect
                v-model="helpForm.transportadora"
                :options-limit="300"
                :limit="2"
                :limit-text="limitText"
                :options="optionsTransportadora"
                track-by="value"
                label="label"
                id="transportadora"
                :hide-selected="true"
                placeholder="Transportadora ( Digite 3 caracteres para pesquisar )"
                tag-placeholder="Selecionar"
                select-label="Selecionar"
                selected-label="Selecionado"
                deselect-label="Remover"
                :searchable="true"
                :loading="isLoadingTransportadora"
                @search-change="listaTransportadora"
              ></multiselect>
              <b-form-feedback
                class="text-danger"
                v-text="helpForm.errors.get('transportadora')"
                v-if="helpForm.errors.has('transportadora')"
              ></b-form-feedback>
            </b-col>
          </b-row>
          <b-row no-gutters>
            <b-col sm="6" md="2">
              <label>Data de Fatura</label>
              <b-form-datepicker
                locale="pt-br"
                reset-button
                placeholder=""
                v-model="helpForm.dt_emi"
                type="text"
                autocomplete="off"
                class="form-control"
                :date-format-options="{
                  day: 'numeric',
                  month: 'numeric',
                  year: 'numeric',
                }"
              >
              </b-form-datepicker>
              <b-form-feedback
                class="text-danger"
                v-text="helpForm.errors.get('dt_emi')"
                v-if="helpForm.errors.has('dt_emi')"
              ></b-form-feedback>
            </b-col>
            <b-col
              v-if="
                this.helpForm.tp_fatura == 3 || this.helpForm.tp_fatura == 4 || this.helpForm.tp_fatura == 5
              "
              sm="6"
              md="2"
            >
              <label>Data de Vencimento</label>
              <b-form-datepicker
                locale="pt-br"
                reset-button
                placeholder=""
                v-model="helpForm.dt_vencto"
                type="text"
                autocomplete="off"
                class="form-control"
                :date-format-options="{
                  day: 'numeric',
                  month: 'numeric',
                  year: 'numeric',
                }"
              >
              </b-form-datepicker>
              <b-form-feedback
                class="text-danger"
                v-text="helpForm.errors.get('dt_emi')"
                v-if="helpForm.errors.has('dt_emi')"
              ></b-form-feedback>
            </b-col>
            <b-col
              v-if="
                this.helpForm.tp_fatura != 3 && this.helpForm.tp_fatura != 4 && this.helpForm.tp_fatura != 5
              "
            >
              <label>Data de Vencimento</label>
              <b-form-input
                type="text"
                placeholder=""
                v-model="helpForm.dt_vencto"
                :disabled="
                  this.helpForm.tp_fatura != 3 && this.helpForm.tp_fatura != 4
                "
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="helpForm.errors.get('dt_vencto')"
                v-if="helpForm.errors.has('dt_vencto')"
              ></b-form-feedback>
            </b-col>

            <b-col>
              <label>Valor Doc Liberado</label>
              <currency-input
                class="form-control"
                v-model="helpForm.vlr_pre_fatura"
                placeholder=""
                readonly
                :auto-decimal-mode="true"
                :locale="getCurrency.locale"
                style="text-align: right"
                :currency="{ prefix: 'R$ ' }"
                :distraction-free="getCurrency"
              />
              <b-form-feedback
                class="text-danger"
                v-text="helpForm.errors.get('vlr_pre_fatura')"
                v-if="helpForm.errors.has('vlr_pre_fatura')"
              ></b-form-feedback>
            </b-col>

            <b-col>
              <label
                v-if="
                  this.helpForm.tp_fatura != 3 && this.helpForm.tp_fatura != 4
                "
                >Valor Fatura</label
              >
              <label
                v-if="
                  this.helpForm.tp_fatura == 3 || this.helpForm.tp_fatura == 4
                "
                >Valor da NFSe</label
              >
              <currency-input
                class="form-control"
                v-model="helpForm.vlr_fatura"
                placeholder=""
                :auto-decimal-mode="true"
                :locale="getCurrency.locale"
                style="text-align: right"
                :currency="{ prefix: 'R$ ' }"
                :distraction-free="getCurrency"
              />
              <b-form-feedback
                class="text-danger"
                v-text="helpForm.errors.get('vlr_fatura')"
                v-if="helpForm.errors.has('vlr_fatura')"
              ></b-form-feedback>
            </b-col>
            <b-col>
              <label>Justificativa</label>
              <b-form-input
                type="text"
                placeholder="Justificativa"
                v-model="helpForm.obs"
                :disabled="
                  this.helpForm.vlr_fatura == this.helpForm.vlr_pre_fatura &&
                    (this.helpForm.tp_fatura != 3 ||
                      this.helpForm.tp_fatura != 4)
                "
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="helpForm.errors.get('obs')"
                v-if="helpForm.errors.has('obs')"
              ></b-form-feedback>
            </b-col>
          </b-row>
          <b-row no-gutters v-if="this.helpForm.tp_fatura == 2">
            <b-col sm="6" md="3">
              <label>Motivo</label>
              <multiselect
                v-model="tpMotivoSelected"
                :options="this.$parent.optionsParamMotivoNf"
                track-by="parmot_id"
                label="label"
                :hide-selected="true"
                placeholder="Motivo"
                tag-placeholder="Selecionar"
                select-label="Selecionar"
                selected-label="Selecionado"
                deselect-label="Remover"
                :disabled="
                  this.helpForm.vlr_fatura == this.helpForm.vlr_pre_fatura
                "
              ></multiselect>
              <b-form-feedback
                class="text-danger"
                v-text="helpForm.errors.get('tp_motivo')"
                v-if="helpForm.errors.has('tp_motivo')"
              ></b-form-feedback>
            </b-col>
          </b-row>
          <b-row no-gutters v-if="this.helpForm.tp_fatura == 5">
            <b-col sm="6" md="3">
              <label>Motivo</label>
              <multiselect
                v-model="paramMotivoSelected"
                :options="this.$parent.optionsParamMotivo"
                track-by="parmot_id"
                label="label"
                :hide-selected="true"
                placeholder="Selecione"
                tag-placeholder="Selecionar"
                select-label="Selecionar"
                selected-label="Selecionado"
                deselect-label="Remover"
              ></multiselect>
              <b-form-feedback
                class="text-danger"
                v-text="helpForm.errors.get('parmot_id')"
                v-if="helpForm.errors.has('parmot_id')"
              ></b-form-feedback>
            </b-col>
            <b-col sm="6" md="3">
              <label>Trecho</label>
              <b-input-group>
                <b-form-input
                  type="text"
                  readonly=true
                  :placeholder="placeholderTrechos"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    variant="outline-info"
                    :disabled="this.helpForm.parmot_id == null"
                    v-on:click="onBuscarTrecho()"
                    >Buscar</b-button
                  >
                </b-input-group-append>
              </b-input-group>
              <b-form-feedback
                class="text-danger"
                v-text="helpForm.errors.get('trechos')"
                v-if="helpForm.errors.has('trechos')"
              ></b-form-feedback>
            </b-col>
          </b-row>
        </b-container>
      </form>
      <div slot="modal-footer" class="w-100">
        <div class="float-left">
          <spinner v-if="loading" message="Processando..."></spinner>
        </div>
        <div class="float-right">
          <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
          <b-btn @click="showModal = false" variant="secondary">
            Fechar
          </b-btn>
          <b-btn
            @click="handleOk($event)"
            variant="secondary"
            :disabled="isDisabled"
          >
            Enviar
          </b-btn>
        </div>
      </div>
    </b-modal>
    <BuscarPedidoUnidadeCargaTrecho ref="buscarpedidounidadecargatrecho">
    </BuscarPedidoUnidadeCargaTrecho>
  </div>
</template>
<script>
import BuscarPedidoUnidadeCargaTrecho from "../components/BuscarPedidoUnidadeCargaTrecho";
import AvisoErros from "../components/AvisoErros";
import moment from "moment";

export default {
  components: {
    AvisoErros,
    BuscarPedidoUnidadeCargaTrecho,
  },
  props: {
    metodo: { type: Function },
    tabela: "",
  },
  data() {
    return {
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      showModalGrupo: false,
      isFullscreen: false,
      errors_array: [],
      optionsTransportadora: [],
      paramMotivoSelected: [],
      tpMotivoSelected: [],
      isDisabledParamMotivo: true,
      placeholderTrechos: "Selecione os trechos",
      helpForm: new Form({
        prefatdes_id: "",
        tp_fatura: "",
        tp_motivo: "",
        num_fiscal: "",
        serie: "",
        prefat_num_fiscal: "",
        nfse_num_fiscal: "",
        transportadora: "",
        pessoa_id: "",
        motivo: "",
        trechos: [],
        dt_emi: "",
        dt_vencto: "",
        vlr_fatura: 0,
        vlr_pre_fatura: 0,
        obs: "",
        parmot_id: "",
      }),
      form: new Form({
        cd: "",
      }),
      searchForm: new Form({ statusRecord: [], params: [], search: "" }),
      fields: [],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  watch: {
    paramMotivoSelected(obj) {
      this.helpForm.parmot_id = obj.value;
    },
    tpMotivoSelected(obj) {
      this.helpForm.tp_motivo = obj.value;
    },
  },
  methods: {
    onBuscarTrecho(data) {
      this.$refs.buscarpedidounidadecargatrecho.onBuscarPedidoUnidadeCargaTrecho(
        data,
        this.helpForm.trechos,
        this.helpForm.parmot_id
      );
    },
    onAssociarTrecho(trechos) {
      this.helpForm.trechos = null;
      this.helpForm.trechos = [];
      this.helpForm.trechos = trechos;

      if(this.helpForm.trechos.length > 0){
        this.placeholderTrechos = this.helpForm.trechos.length + " trecho(s) selecionado(s).";
        this.helpForm.transportadora = trechos[0].transportadora;

        trechos.forEach((obj) => {
          console.log("Valor Custo");
          console.log(obj.vlr_custo);
          this.helpForm.vlr_pre_fatura += parseFloat(obj.vlr_custo);
        });
      } else {
        this.placeholderTrechos = "Selecione os trechos";
        this.helpForm.vlr_pre_fatura = 0;
        this.helpForm.transportadora = "";
      }
    },
    listaTransportadora(search) {
      if (search.length >= 3) {
        this.isLoadingTransportadora = true;
        this.searchForm.search = search;
        this.searchForm.status = 1;
        this.searchForm
          .post("/api/pessoa/jsonlist/transportadora")
          .then((response) => {
            this.optionsTransportadora = [];
            new ReturnApi(response, this, true, false, false);
            if (response.items.length > 0) {
              response.items.forEach((obj) => {
                this.optionsTransportadora.push({
                  label:
                    "PJ -" +
                    obj.pessoa.cd +
                    " - " +
                    obj.razao_social +
                    " - " +
                    this.onFormataCnpj(
                      obj.cnpj_base,
                      obj.cnpj_filial,
                      obj.cnpj_digito
                    ) +
                    " - " +
                    obj.inscricao_estadual,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            if (response.itemsF.length > 0) {
              response.itemsF.forEach((obj) => {
                this.optionsTransportadora.push({
                  label: "PF -" + obj.nome + " - " + obj.cpf,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            if (response.itemsE.length > 0) {
              response.itemsE.forEach((obj) => {
                this.optionsTransportadora.push({
                  label: "PE -" + obj.nome + " - " + obj.cd,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            this.isLoadingTransportadora = false;
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
      }
    },
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.helpForm.docfis_id);
      }
    },
    onCreate() {
      this.isDisabled = false;
      this.loading = false;
      this.paramMotivoSelected = [];
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.item = [];
      this.tpDocSelected = [];
      this.errors_array = [];
      this.tpMotivoSelected = [];
      this.emiMunicipioSelected = [];
      this.desMunicipioSelected = [];
      this.redMunicipioSelected = [];
      this.placeholderTrechos = "Selecione os trechos";
      this.helpForm.reset();
      this.helpForm.vlr_unitario = parseFloat(this.helpForm.vlr_unitario);
      this.helpForm.peso_bruto = parseFloat(this.helpForm.peso_bruto);
      this.helpForm.vlr_total_nfe = parseFloat(this.helpForm.vlr_total_nfe);
      // this.helpForm.vlr_fatura = 1;
      this.$refs.modal_form.show();
    },
    onStore() {
      if (this.helpForm.vlr_fatura == this.helpForm.vlr_pre_fatura) {
        this.helpForm.obs = "";
      }
      this.helpForm
        .put("/api/faturadespesa/store")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      this.helpForm.item = this.item;
      if (this.helpForm.tp_fatura != 2) {
        this.tpMotivoSelected = []
      }
      if (this.helpForm.emi_cnpj_cpf_cuit != null) {
        this.helpForm.emi_cnpj_cpf_cuit = this.helpForm.emi_cnpj_cpf_cuit.replace(
          /([-./])/g,
          ""
        );
      }
      if (this.helpForm.des_cnpj_cpf_cuit != null) {
        this.helpForm.des_cnpj_cpf_cuit = this.helpForm.des_cnpj_cpf_cuit.replace(
          /([-./])/g,
          ""
        );
      }
      if (this.helpForm.red_cnpj_cpf_cuit != null) {
        this.helpForm.red_cnpj_cpf_cuit = this.helpForm.red_cnpj_cpf_cuit.replace(
          /([-./])/g,
          ""
        );
      }
      this.helpForm
        .patch("/api/docfiscal/update/" + id)
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    searchPreFatura() {
      if(this.helpForm.prefat_num_fiscal == ""){
        this.helpForm.transportadora = "";
        this.helpForm.dt_vencto = "";
        this.helpForm.vlr_pre_fatura = "";
      }
      if (this.helpForm.tp_fatura != 3 && this.helpForm.tp_fatura != 4) {
        this.helpForm
          .get(
            "/api/prefaturadespesa/getbynumfiscal?num_fiscal=" +
              this.helpForm.prefat_num_fiscal.toString().replace(/^0+/, "")
          )
          .then((response) => {
            this.helpForm.pessoa_id = response.item.pessoa.pessoa_id;
            this.helpForm.transportadora =
              response.item.pessoa.cd +
              " - " +
              response.item.pessoa.pessoa_juridica.razao_social +
              " - " +
              this.onFormataCnpj(
                response.item.pessoa.pessoa_juridica.cnpj_base,
                response.item.pessoa.pessoa_juridica.cnpj_filial,
                response.item.pessoa.pessoa_juridica.cnpj_digito
              ) +
              " - " +
              response.item.pessoa.pessoa_juridica.inscricao_estadual;
            this.helpForm.dt_vencto = this.formatDateSubmit(
              response.item.dt_vencto
            );

            this.helpForm.vlr_pre_fatura = response.item.vlr_pre_fatura;

            new ReturnApi(response, this, true, false, false);
          })
          .catch((errors) => {
            this.isDisabled = true;
            new ReturnApi(errors, this);
          });
      }
    },
    removeRow: function(index_item) {
      this.item.splice(index_item, 1);
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY-MM-DD HH:mm").format(fmt);
    },
    onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      var cnpj_formatado;
      var pad = "00000000";
      var cnpj_base =
        pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
      var pad = "0000";
      var cnpj_filial =
        pad.substring(0, pad.length - cnpj_filial.toString().length) +
        cnpj_filial;
      var pad = "00";
      var cnpj_digito =
        pad.substring(0, pad.length - cnpj_digito.toString().length) +
        cnpj_digito;
      return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
    },
    onActivateDesactivate(helpForm) {
      helpForm
        .patch("/api/unidade/status")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    getCurrency: {
      get() {
        return this.$store.getters.currency;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
  },
};
</script>
